import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { InsuranceFormOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/insurance-form/insurance-form-wrapper.component';

@Component({
  selector: 'app-insurance-form',
  templateUrl: './insurance-form.component.html',
  styleUrls: ['./insurance-form.component.scss'],
})
export class InsuranceFormComponent extends InsuranceFormOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
